import { useState } from 'react';
import Avatar from '../avatar';
import Badge from '../badge';
import Label from '../label';
interface AvatarProps {
    imageUrl: any;
    title: string;
    subTitle?: string;
    onClickHandler?: any;
    className?: any;
    size?: string;
    status?: string;
    agreed_endorsements?: number;
    disagreed_endorsements?: number;
    pending_endorsements?: number;
    projects?: string[];
    recognitionFor?: string[];
    showTooltip?: boolean;
    parentClassName?: string;
    titleClassName?: string;
    avatarClassName?: string;
    isViewMore: boolean;
}

export default function AvatarCard({ imageUrl, onClickHandler, className, title, subTitle, size = 'sm', status, agreed_endorsements, disagreed_endorsements, pending_endorsements, projects, recognitionFor, showTooltip = false, parentClassName, titleClassName = "font-aeonikReg", avatarClassName, isViewMore }: AvatarProps) {

    const [isExpanded, setIsExpanded] = useState(false);


    const toggleExpanded = () => setIsExpanded(prev => !prev);

    const getTitleTextSize = () => {
        switch (size) {
            case 'xs':
                return "text-[0.75rem]";
            case 'sm':
                return "text-[0.875rem]";
            case 'md':
                return "text-[1rem]";
            case 'lg':
                return "text-[1.25rem]";
            case 'xl':
                return "text-[1.5rem]";
            default:
                return "";
        }
    };

    const getSubTitleTextSize = () => {
        switch (size) {
            case 'xs':
                return "text-[12px]";
            case 'sm':
                return "text-[12px]";
            case 'md':
                return "text-[12px]";
            case 'lg':
                return "";
            case 'xl':
                return "text-[16px]";
            default:
                return "";
        }
    };

    return (
        <div className={`flex flex-row ${parentClassName}`}>
            <div className={`flex flex-row items-center ${className}`} onClick={onClickHandler} >
                <Avatar imageUrl={imageUrl} size={size} className={avatarClassName} />
                <div className='flex flex-col ml-2 avatar-content'>
                    <div className='flex flex-col'>
                        <div
                            className={`${getTitleTextSize()} flex text-labelTextCol text-sm ${titleClassName} avatar-heading
                              ${isViewMore && !isExpanded ? 'truncate max-w-[150px]' : ''}
                                     ${showTooltip ? 'truncate max-w-[150px]' : ''} `}
                            title={title}
                        >
                            <span className="overflow-hidden whitespace-wrap text-ellipsis">
                                {title}
                            </span>
                            {status === 'pending' && (
                                <div className='flex capitalize ml-3 mt-0 text-pendingDark text-sm font-aeonikBold'>
                                    {status}
                                </div>
                            )}
                        </div>

                        {isViewMore && title.length > 40 && (
                            <button
                                onClick={toggleExpanded}
                                className='text-blue-600 text-xs mt-1 self-start hover:underline focus:outline-none'
                            >
                                {isExpanded ? 'View Less' : 'View More'}
                            </button>
                        )}
                    </div>

                    {subTitle ? <div className={`${getSubTitleTextSize()} text-darkGrey font-aeonikReg avatar_subheading !text-xs`}>{subTitle}</div> : ''}
                    {(agreed_endorsements || disagreed_endorsements || pending_endorsements) ? <div className="grid grid-cols-3 gap-1.5">
                        {(agreed_endorsements && (agreed_endorsements > 0)) ? <div>
                            <Label label={`${agreed_endorsements} Endorsed`} className="!text-approvedDark font-bold !mb-0" />
                        </div> : null}
                        {(disagreed_endorsements && (disagreed_endorsements > 0)) ? <div>
                            <Label label={`${disagreed_endorsements} Disagreed`} className="text-rejectDark font-bold !mb-0" />
                        </div> : null}

                        {(pending_endorsements && (pending_endorsements > 0)) ? <div>
                            <Label label={`${pending_endorsements} Pending`} className="text-pendingDark font-bold !mb-0" />
                        </div> : null}
                    </div> : ''}
                    {projects && Array.isArray(projects) ? (
                        <div className='flex gap-1 flex-wrap text-sm font-medium mt-1'>
                            {projects.map((item: any, index: number) => {
                                const isLastItem = index === projects.length - 1;
                                const projectName = item?.project?.name || item?.name || "Unnamed Project"; // Fallback for missing name

                                return (
                                    <p key={index} className='flex text-labelTextCol !text-xs font-aeonikReg avatar-heading'>
                                        {projectName}
                                        {!isLastItem && " | "}
                                    </p>
                                );
                            })}
                        </div>
                    ) : null}


                    {/* {recognitionFor && Array.isArray(recognitionFor) ? (
                        recognitionFor?.length > 0 ? (
                            <div className='mt-2'>
                                <Label label="Recognized For" className="text-labelTextCol !text-base !font-aeonikReg !text-sm" />
                                <div className="flex gap-1 flex-wrap !text-sm font-medium">
                                    {recognitionFor.map((item: any, index: number) => (
                                        <Badge key={index} name={item?.recognition?.title || (typeof item === 'string' ? item : 'Unnamed Recognition')} className="!p-1.5" />
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <p className="text-gray-400 mt-2">No recognitions available.</p>
                        )
                    ) : null} */}



                    {recognitionFor && Array.isArray(recognitionFor) ? (
                        recognitionFor?.length > 0 ? (
                            <div>
                                <Label label="Recognized For" className="text-labelTextCol !text-base !font-aeonikReg !text-sm" />
                                <div className="flex flex-wrap gap-2 text-sm font-medium">

                                    {recognitionFor.map((item: any, index: number) => (
                                        <div
                                            key={index}
                                            className="text-xs font-aeonikReg border border-black rounded-basicRadius px-2 py-1 break-words whitespace-normal max-w-[200px]"
                                        >
                                            <span className="block">{item?.recognition?.title}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <p className="text-gray-400 mt-2">No recognitions available.</p>
                        )
                    ) : null}


                </div>
            </div>

        </div >
    );
};


